import React, { useState } from "react";
import puzzleGameImg from "../assets/img/EDUbox-puzzle-game.png";
import lectureGameImg from "../assets/img/EDUbox-lecture-game.png";
import interactiveVideoImg from "../assets/img/EDUbox-interactive-video.png";
import coOpGameImg from "../assets/img/EDUbox-co-op-game.png";

export const fetchToolsGeneral = async () => {
  const baseurl = window.location.href.includes("localhost")
        ? "http://localhost:1337"
        // ? "https://dudwpkgwkyw9w.cloudfront.net"
        : "https://dudwpkgwkyw9w.cloudfront.net";

  const apiUrl = `${baseurl}/api/third-party-tools/`;
  const myHeaders = new Headers();

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(apiUrl, requestOptions);
    if (!response.ok) {
      throw new Error("Data cannot be retrieved, database is not responding.");
    }
    const data = await response.json();
    if (!data.data) {
      throw new Error(
        "No data were found for the corresponding game from the database."
      );
    }
    const tools = data.data;
    const puzzlegame = fetchMainTools(baseurl, requestOptions, {tool_id:"puzzlegames",tool_name:"Puzzeltijd", tool_url: "puzzlegame/"}, {url:puzzleGameImg, alt: "logo van puzzeltijd" });
    const lecturegame = fetchMainTools(baseurl, requestOptions, {tool_id:"lecture-games",tool_name:"Spreekbeurt", tool_url: "lecture-game/"}, {url:lectureGameImg, alt: "logo van spreekbeurt" });
    const interactivevideo = fetchMainTools(baseurl, requestOptions, {tool_id:"interactive-videos",tool_name:"Interactieve video", tool_url: "interactive-video/"}, {url:interactiveVideoImg, alt: "logo van interactive video" });
    const coopgame = fetchMainTools(baseurl, requestOptions, {tool_id:"co-op-games",tool_name:"Co-Op spel", tool_url: "co-op-game/"}, {url:coOpGameImg, alt: "logo van co-op spel" });

    // Fetch detailed data for each tool
    const detailedTools = await Promise.all(
      tools.map(async (tool) => {
        const toolDetailUrl = `${baseurl}/api/third-party-tools/${tool.attributes.tool_id}`;
        const toolDetailResponse = await fetch(toolDetailUrl, requestOptions);
        if (!toolDetailResponse.ok) {
          throw new Error(
            `Failed to fetch details for tool: ${tool.attributes.tool_id}`
          );
        }
        const toolDetailData = await toolDetailResponse.json();
        const toolItems = toolDetailData.data.attributes.toolData.tool_items;
        const EDUbox = [];
        toolItems.map((toolItem) => {
          const a = { tool_name: toolItem.name, tool_id: toolItem.tool_id };
          EDUbox.push(a);
        });

        return {
          ...tool,
          banner: toolDetailData.data.attributes.toolData.banner,
          EDUbox: EDUbox,
          toolUrl: `tools/tool/?toolname=${tool.attributes.tool_id}`
        };
      })
    );
    detailedTools.unshift(await puzzlegame, await lecturegame, await interactivevideo, await coopgame);
    return detailedTools;
  } catch (error) {
    console.log(error.message);
    return null;
  }
};

const fetchMainTools = async (baseurl, requestOptions, game,banner) => {
  const apiUrl = `${baseurl}/api/${game.tool_id}/`;
  try {
    const response = await fetch(apiUrl, requestOptions);
    if (!response.ok) {
      throw new Error("5. Data cannot be retrieved, database is not responding.");
    }
    const data = await response.json();
    if (!data.data) {
      throw new Error(
        "6. No data were found for the corresponding game from the database."
      );
    }
    const EDUbox =  data.data.map( (tool) => {
        if(tool.attributes.name !== undefined){
            return { tool_name: tool.attributes.name, tool_id: tool.attributes.game_id }
        }else if (tool.attributes.game_title !== undefined){
            return { tool_name: tool.attributes.game_title, tool_id: tool.attributes.game_id }
        }else {
            return { tool_name: tool.attributes.game_label, tool_id: tool.attributes.game_id }
        }
    });
    return {
        attributes: {
            banner_alt: banner.alt,
            // description: "## Met de Reflector app kunnen leerlingen foto's insturen voor vooraf bepaalde onderwerpen.\n\n**Je maakt** een groepsnaam aan per klasgroep én per challenge. Daarbij moet je ook enkele criteria aanduiden die van toepassing zijn op de groep. De leerlingen moeten deze groepsnaam invullen vooraleer ze hun foto’s kunnen opladen. Aan je klasgroep geef je dus een groepsnaam mee voor elke challenge die ze moeten doen!\n\nDankzij deze groepsnaam worden alle beelden van één opdracht op dezelfde plaats verzameld. Als je inlogt op bovenstaande pagina, krijg je een overzicht te zien van de foto’s die de leerlingen hebben ingezonden. Je kan ze ook vergelijken met de beelden van andere jongeren in Vlaanderen. Dit dashboard dien je te gebruiken in het reflectiemoment (zie hieronder).\n\nAls leerkracht dien je vooraf per challenge een groepsnaam aan te maken. ",
            tool_id: game.tool_id,
            tool_name: game.tool_name,
            visible_for_teacher: true
        },
        toolUrl: game.tool_url,
        banner: {url: banner.url},
        EDUbox: EDUbox,
      };
  } catch (error) {
    console.log(error.message);
    return null;
  }
};
